import { T } from '@tribeplatform/react-components/i18n'

import { FlaggedMembers } from '../FlaggedMembers.js'

export function FlaggedMembersRouter() {
  return <FlaggedMembers />
}

export function FlaggedMembersBreadCrumb() {
  return <T id="Moderation.FlaggedMembers" defaultMessage="Flagged Members" />
}
